import { capture } from "./capture";

export const IntegrationsTracking = {
  /** New integration created successfully. */
  created: (integrationType: string) => {
    capture("integrations.created", { integration_type: integrationType });
  },

  /** Integration deleted. */
  deleted: (integrationId: string, integrationType: string) => {
    capture("integrations.deleted", {
      integration_id: integrationId,
      integration_type: integrationType,
    });
  },

  /** Onboarding command copied to clipboard. */
  onboardingCommandCopied: (integrationId: string) => {
    capture("integrations.onboarding_command_copied", { integration_id: integrationId });
  },
};
